import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { DashboardConstants } from 'src/redux/actions/constant';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';

const {
  GET_DASHBOARD_OVERVIEW_REQUEST,
  GET_DASHBOARD_OVERVIEW_FAILURE,
  GET_DASHBOARD_OVERVIEW_SUCCESS,
  GET_DASHBOARD_OVERVIEW_LOADER,
} = DashboardConstants;

function* dashboardOverview(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_DASHBOARD_OVERVIEW_LOADER });
    const response = yield call(dashboardServices.getDashboardOverView, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_DASHBOARD_OVERVIEW_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_DASHBOARD_OVERVIEW_FAILURE, payload: error });
  }
}

function* dashboardTaskOverviewSaga() {
  yield takeEvery(GET_DASHBOARD_OVERVIEW_REQUEST, dashboardOverview);
}

export default dashboardTaskOverviewSaga;
